'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetStartOpen = undefined;

var _reselect = require('reselect');

var _getStartOpen = require('../operators/getStartOpen');

var _getWidgetUiState = require('../../selectors/getWidgetUiState');

var getWidgetStartOpen = exports.getWidgetStartOpen = (0, _reselect.createSelector)([_getWidgetUiState.getWidgetUiState], function (widgetUiState) {
  return (0, _getStartOpen.getStartOpen)(widgetUiState);
});